import React from "react";
import { logout } from "./apiAuth";

const SecurityQuickLink = () => {
  const path = window.location.pathname;

  if (path === "/singin" || path === "/login") {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        right: "18px",
        bottom: "18px",
        zIndex: 9999,
        display: "flex",
        gap: "10px",
        alignItems: "center",
      }}
    >
      <a
        href="/active-devices"
        style={{
          background: "#4b2e20",
          color: "#fff",
          padding: "12px 16px",
          borderRadius: "999px",
          textDecoration: "none",
          fontWeight: 700,
          boxShadow: "0 10px 25px rgba(0,0,0,0.22)",
        }}
      >
        Security
      </a>

      <button
        onClick={logout}
        style={{
          background: "#7f1d1d",
          color: "#fff",
          padding: "12px 16px",
          borderRadius: "999px",
          border: 0,
          fontWeight: 700,
          cursor: "pointer",
          boxShadow: "0 10px 25px rgba(0,0,0,0.22)",
        }}
      >
        Logout
      </button>
    </div>
  );
};

export default SecurityQuickLink;
